var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHabitsSalty = function SvgHabitsSalty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c2e8ff",
    d: "M22.2 77.5c-3.5-2.8-7.7-12-7.7-19.5 0-10.7 5-19.4 9.1-26.3 2.8-4.7 4.9-8.5 4.9-11.7V8.5h23V20c0 3.2 2.2 6.9 4.9 11.7 4 6.9 9.1 15.6 9.1 26.3 0 7.5-4.2 16.7-7.7 19.5H22.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7496c4",
    d: "M51 9v11c0 3.4 2.2 7.1 5 11.9 4 6.9 9 15.5 9 26.1 0 7.2-4 16.1-7.4 19H22.4C19 74.1 15 65.2 15 58c0-10.6 5-19.2 9-26.1 2.8-4.8 5-8.6 5-11.9V9h11zm1-1H28v12c0 7.8-14 20-14 38 0 7.5 4.3 17.1 8 20h36c3.8-2.9 8-12.5 8-20 0-18-14-30.2-14-38z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.8 75H23.2C20.5 72.2 17 64.5 17 58c0-10.1 4.8-18.4 8.7-25.1 2.9-5 25.6-5 28.5 0 3.9 6.7 8.7 15 8.7 25.1.1 6.5-3.4 14.2-6.1 17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd5f2",
    d: "M28 17.5c-.8 0-1.5-.7-1.5-1.5V6.4c0-.5.3-1 .7-1.3 1.7-1 5.5-2.6 12.8-2.6s11.1 1.7 12.8 2.6c.4.3.7.7.7 1.3V16c0 .8-.7 1.5-1.5 1.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b75a1",
    d: "M40 3c7.1 0 10.9 1.6 12.5 2.6.3.2.5.5.5.8V16c0 .6-.4 1-1 1H28c-.6 0-1-.4-1-1V6.4c0-.4.2-.7.5-.9C29.1 4.6 32.9 3 40 3m0-1c-7.4 0-11.4 1.7-13 2.7-.6.4-1 1-1 1.7V16c0 1.1.9 2 2 2h24c1.1 0 2-.9 2-2V6.4c0-.7-.4-1.4-1-1.7-1.6-1-5.6-2.7-13-2.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b75a1",
    d: "M45 6c-.6 0-1-.4-1-1V3.4c0-.6.4-1 1-1s1 .4 1 1V5c0 .6-.4 1-1 1M35 6c-.6 0-1-.4-1-1V3.4c0-.6.4-1 1-1s1 .4 1 1V5c0 .6-.4 1-1 1"
  })));
};
export default SvgHabitsSalty;